import { setSmoothScroll } from './modules/set-smooth-scroll';
import { prepareGlobalMenu } from './modules/prepare-global-menu';
import { prepareMovieOverlay } from './modules/prepare-movie-overlay';
import { prepareHeaderOnVideo } from './modules/prepare-header-on-video';

setSmoothScroll();
prepareGlobalMenu();
prepareMovieOverlay();
prepareHeaderOnVideo();
